<template>
    <div class="wrap">
        <TheHeader />
        <main>
            <div class="content inner">
                <div class="cate row mtb80">
                    <div class="left box">
                        <div class="search_wrap">
                            <input
                              type="text"
                              name="search"
                              placeholder="키워드 검색"
                              v-model="search"
                            />
                            <button type="button" @click="doSearch"><img src="@/assets/search_ic.svg"></button>
                        </div>
                        <div class="category"> 
                            <ul class="main">
                                <li @click="goCategory(1, 0)" :class="{ active: activeType === 1 }">
                                    <p>태양광 모듈<!--span class="material-symbols-outlined">keyboard_arrow_down</span--></p>
                                    <ul class="sub">
                                        <li @click.stop="goCategory(1, 1)">
                                            <div class="sub_title_flex" @click.stop="toggleSub(0)">
                                                결정질 실리콘 태양광 모듈
                                                <span class="material-symbols-outlined">{{ openSubMenu[0] ? 'expand_less' : 'expand_more' }}</span>
                                            </div>
                                            <ul class="company_list" v-show="openSubMenu[0]">
                                                <li v-for="com in getCompaniesByCate('11')" :key="com.id" @click.stop="doSearchCompany(com.company_name)" :class="{ 'selected-company': selectedCompany === com.company_name }">
                                                    - {{ com.company_name }}
                                                </li>
                                            </ul>
                                        </li>

                                        <li @click.stop="goCategory(1, 2)">
                                            <div class="sub_title_flex" @click.stop="toggleSub(1)">
                                                박막 태양광 모듈
                                                <span class="material-symbols-outlined">{{ openSubMenu[1] ? 'expand_less' : 'expand_more' }}</span>
                                            </div>
                                            <ul class="company_list" v-show="openSubMenu[1]">
                                                <li v-for="com in getCompaniesByCate('12')" :key="com.id" @click.stop="doSearchCompany(com.company_name)" :class="{ 'selected-company': selectedCompany === com.company_name }">
                                                    - {{ com.company_name }}
                                                </li>
                                            </ul>
                                        </li>    
                                    </ul>
                                </li>

                                <li @click="goCategory(2, 0)" :class="{ active: activeType === 2 }">
                                    <p>단열재</p>
                                    <ul class="sub">
                                        <li @click.stop="goCategory(2, 1)">
                                            <div class="sub_title_flex" @click.stop="toggleSub(2)">
                                                외단열재
                                                <span class="material-symbols-outlined">
                                                    {{ openSubMenu[2] ? 'expand_less' : 'expand_more' }}
                                                </span>
                                            </div>
                                            <ul class="company_list" v-show="openSubMenu[2]">
                                                <li v-for="com in getCompaniesByCate('21')" :key="com.id" @click.stop="doSearchCompany(com.company_name)" :class="{ 'selected-company': selectedCompany === com.company_name }">
                                                    - {{ com.company_name }}
                                                </li>
                                                <li v-if="getCompaniesByCate('21').length === 0" class="no-data">- 등록된 회사 없음</li>
                                            </ul>
                                        </li>

                                        <li @click.stop="goCategory(2, 2)">
                                            <div class="sub_title_flex" @click.stop="toggleSub(3)">
                                                내단열재
                                                <span class="material-symbols-outlined">
                                                    {{ openSubMenu[3] ? 'expand_less' : 'expand_more' }}
                                                </span>
                                            </div>
                                            <ul class="company_list" v-show="openSubMenu[3]">
                                                <li v-for="com in getCompaniesByCate('22')" :key="com.id" @click.stop="doSearchCompany(com.company_name)" :class="{ 'selected-company': selectedCompany === com.company_name }">
                                                    - {{ com.company_name }}
                                                </li>
                                                <li v-if="getCompaniesByCate('22').length === 0" class="no-data">- 등록된 회사 없음</li>
                                            </ul>
                                        </li>
                                    </ul>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="right box">
                        <!--h2>▶ KOES <span></span></h2-->
                        <div class="list_box">
                            <div class="box" v-for="item in libraries" :key="item.id + '-' + pagination.current_page">
                                <a href="#" @click.prevent="goView(item)">
                                    <div class="head">
                                        <img :src="item.list_img ? apiBaseUrl + '/' + item.list_img :  apiBaseUrl + '/no_photo.jpg'">
                                    </div>
                                </a> 
                                <div class="body">    
                                    <h3>{{ item.module_name }}</h3>
                                    <div class="cont">
                                        <span>제조사 : {{ item.company }}</span>
                                        <span>모델명 : {{ item.module_name }}</span>
                                        <span>색상 : {{ item.color }}</span>
                                    </div>                
                                    <!--div class="bottom">
                                        <button type="button" @click="download(item)">다운로드</button>
                                        <span>{{ item.point }}p</span>
                                    </div-->
                                </div>                            
                            </div>
                        </div>
                        
                        <div class="pagination" v-if="pagination && pagination.last_page > 1">
                            <a
                                href="#"
                                v-if="pagination.current_page > 1"
                                class="prev"
                                :class="{ disabled: pagination.current_page === 1 }"
                                @click.prevent="goPage(pagination.current_page - 1)"
                            >
                                <svg
                                    id="_레이어_1"
                                    data-name="레이어 1"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 7.45 12.08"
                                >
                                    <path
                                    d="M.71,11.37l5.33-5.33L.71.71"
                                    fill="none"
                                    stroke="#1b1e23"
                                    stroke-width="2"
                                    />
                                </svg>
                            </a>

                            <a
                                v-for="page in pagination.last_page"
                                :key="page"
                                href="#"
                                :class="{ active: page === pagination.current_page }"
                                @click.prevent="goPage(page)"
                            >
                                {{ page }}
                            </a>

                            <a
                                href="#"
                                v-if="pagination.current_page < pagination.last_page"
                                class="next"
                                :class="{ disabled: pagination.current_page === pagination.last_page }"
                                @click.prevent="goPage(pagination.current_page + 1)"
                            >
                                <svg
                                    id="_레이어_1"
                                    data-name="레이어 1"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 7.45 12.08"
                                >
                                    <path
                                    d="M.71,11.37l5.33-5.33L.71.71"
                                    fill="none"
                                    stroke="#1b1e23"
                                    stroke-width="2"
                                    />
                                </svg>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </main>
        <TheFooter />
    </div>
</template>

<script>
import TheHeader from '@/components/TheHeader.vue'   
import TheFooter from '@/components/TheFooter.vue'
import api from '@/api'

export default {
  name: 'BIM_LibraryMarket',
  components: {
    TheHeader,
    TheFooter
  },
  data() {
    return {
      search: '',
      selectedCompany: '',
      activeType: 0,
      libraries: [],
      pagination: null,
      isLoggedIn: false,
      user: null,
      companyList: [],    
      openSubMenu: [false, false, false, false],
    }
  },
async mounted() {
        await this.checkAuth();

        this.syncQueryToData();

        this.fetchLibraries();
  },
watch: {
  '$route.query': {
    immediate: false,
    handler() {
      this.syncQueryToData();
      this.fetchLibraries();
    }
  }
},
methods: {
    doSearchCompany(companyName) {
    // 이미 선택된 회사를 다시 누르면 해제 (토글 기능)
    this.selectedCompany = this.selectedCompany === companyName ? '' : companyName;
    
    this.executeSearch();
  },

  // 2. 검색 버튼 클릭 시 실행
  doSearch() {
    this.executeSearch();
  },

  // 3. 공통 검색 실행 함수 (쿼리 생성)
  executeSearch() {
    const query = { 
      ...this.$route.query, 
      page: 1 
    };

    // 키워드가 있으면 넣고 없으면 제거
    if (this.search?.trim()) query.search = this.search.trim();
    else delete query.search;

    // 회사명이 있으면 넣고 없으면 제거
    if (this.selectedCompany) query.company = this.selectedCompany;
    else delete query.company;

    this.$router.push({ path: this.$route.path, query });
  },
  
  // mounted나 watch에서 쿼리 정보를 변수에 동기화
  syncQueryToData() {
    const q = this.$route.query;
    this.search = q.search || '';
    this.selectedCompany = q.company || '';
    this.activeType = q.type ? Number(q.type) : 1;
  },    
      async download(item) {
        if (!this.isLoggedIn) {
              const ok = confirm(
                "로그인이 필요한 서비스입니다.\n\n로그인 페이지로 이동합니다"
              );

          if (ok) {
              const referer = window.location.pathname + window.location.search;
              window.location.href =
                `/login_form?referer=${encodeURIComponent(referer)}`;
              }
              return;
        }

        try {
          const res = await api.post(
            '/admin/library_download',
            { library_id: item.id },
            { withCredentials: true }
          );

          if (res.data.success) {
            // 파일 다운로드
            window.location.href = this.apiBaseUrl + '/' + res.data.download_url;
          } else {
            alert(res.data.message);
          }
        } catch (e) {
          alert('다운로드 중 오류가 발생했습니다.');
        }
      },

  goView(item) {
    const targetUrl = `/bim_library_market_view?id=${item.id}&type=${item.type}&cate=${item.cate}`;

    window.location.href = targetUrl;
  },

  async checkAuth() {
    try {
      const res = await api.get('/admin/auth_check', { withCredentials: true });
      if (res.data.logged_in) {
        this.isLoggedIn = true;
        this.user = res.data.user;
      } else {
        this.isLoggedIn = false;
        this.user = null;
      }
    } catch (e) {
      this.isLoggedIn = false;
    }
  },
  goCategory(type, cate) {
    const query = { type, cate };
    if (this.search && this.search.trim() !== '') {
      query.search = this.search.trim()
    }

    this.$router.push({ path: this.$route.path, query });
  },
  goPage(page) {
    if (!page || page < 1 || page > this.pagination.last_page) return;

    this.$router.push({
      path: this.$route.path,
      query: {
        ...this.$route.query,
        page
      }
    });
  },

  async fetchLibraries() {
    try {
      this.libraries = []
      const params = {
        ...this.$route.query,
        page: this.$route.query.page || 1
      }

      const res = await api.get('/admin/api_library', {
        params
      });
      if (res.data.libraries) {
      this.libraries = res.data.libraries.data; // 페이징 안의 실제 데이터 리스트
      this.pagination = res.data.libraries;      // 페이징 정보 전체
    } else {
      // 만약 PHP API에서 구조를 바꾸지 않았다면 대비책
      this.libraries = res.data.data;
      this.pagination = res.data;
    }
      this.companyList = res.data.company_list;
      console.log("library:"+res.data.data);
    } catch (e) {
      console.error(e);
    }
  },
  toggleSub(index) {
    // Vue 3에서는 단순히 값을 대입하면 반응성이 작동합니다.
    this.openSubMenu[index] = !this.openSubMenu[index];
    
    // 하지만 배열 내부의 값 변경을 Vue가 더 확실히 감지하게 하려면 
    // 아래와 같이 새로운 배열을 할당하는 방식이 가장 안전합니다.
    this.openSubMenu = [...this.openSubMenu];
},
  getCompaniesByCate(cate) {
    // 해당 카테고리에 맞는 회사들만 필터링
    return this.companyList.filter(c => String(c.category) === String(cate));
  }
},
computed: {
    apiBaseUrl() {
      return api.defaults.baseURL || ''
    }
  }
}
</script>
